<div class="no-role-wrapp" *ngIf="isLogged">
  <div class="no-role-card">
    <mat-icon class="no-role-icon">lock_outline</mat-icon>

    <h1 class="no-role-title">{{ 'NO_ROLE_TITLE' | pTranslate }}</h1>

    <p class="no-role-message">{{ 'NO_ROLE_MESSAGE' | pTranslate }}</p>

    <div class="no-role-data" *ngIf="hasAnyData">
      <h2 class="no-role-data-title">{{ 'NO_ROLE_YOUR_DATA' | pTranslate }}</h2>

      <div class="no-role-data-row" *ngIf="fullName">
        <span class="no-role-data-label">{{ 'NO_ROLE_NAME' | pTranslate }}</span>
        <span class="no-role-data-value">{{ fullName }}</span>
      </div>

      <div class="no-role-data-row" *ngIf="username">
        <span class="no-role-data-label">{{ 'NO_ROLE_USER' | pTranslate }}</span>
        <span class="no-role-data-value">{{ username }}</span>
      </div>

      <div class="no-role-data-row" *ngIf="email">
        <span class="no-role-data-label">{{ 'NO_ROLE_EMAIL' | pTranslate }}</span>
        <span class="no-role-data-value">{{ email }}</span>
      </div>
    </div>
  </div>
</div>
